import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from 'framework/Icon';

import { useFieldTheme } from '../../field/hooks/useFieldTheme';
import { useDropdownContext } from '../context/DropdownContext';

import cn from './Component.module.scss';

export const InputIcon = ({ icon }: { icon: IconDefinition }) => {
  const { inputRef, onBlur, onFocus } = useDropdownContext();
  const { color } = useFieldTheme();

  return (
    <Icon icon={icon} theme={color} width="100%">
      <input className={cn.input} ref={inputRef} onBlur={onBlur} onFocus={onFocus} readOnly />
    </Icon>
  );
};
